import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from '../components/layout';
import DefaultProduct from '../components/pages/products/default-product';
import FullWidth from "../components/pages/categories/shop-full-width";

export default class ProductsRoute extends React.Component {
  render() {
    return (
      <Layout>
        <Routes>
          <Route path='/:category_slug?' element={<FullWidth />} />
          <Route path='/:category_slug/:product_slug' element={<DefaultProduct />} />
        </Routes>
      </Layout>
    );
  }
}